import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(theme => ({
  title: {
    fontSize: '32px',
    lineHeight: '42px',
    fontWeight: 700,
    fontFamily: 'TTRounds',
    marginBottom: '20px',
    marginTop: 0,
  },
}))

const CompTitle = ({ text, align }) => {
  const classes = useStyles()

  return (
    <h2 className={classes.title} style={{ textAlign: !align ? 'left' : align }}>
      {text}
    </h2>
  )
}

export default CompTitle
